import * as Actions from 'store/actions/app/_products.actions'

const initialState = {
  downloading_product_prices_list_pdf: false,


  all_products: null,

  loading_products: false,
  products: [],
  total_products: 0,

  loading_products_found: false,
  products_found: [],

  downloading_valued_inventory_report: false,
  downloading_product_shipment_pdf: false,

  loading_movements_by_product: false,
  movements_by_product: null,

  sorts: null,
  subsorts: null,
  brands: null,
  materials: null,
  presentations: null,
  typeexistences: null,

  loading_unit_measures_product: false,
  unit_measures_product: null,

  loading_last_cost_price_product: false,
  last_cost_price_product: null,

  loading_crud_product: false,
  crud_product: false,
  crud_product_data: null,

  loading_stock_product: false,
  stock_product: null,

  set_crud_sort: null,
  set_crud_subsort: null,
  set_crud_brand: null,
  set_crud_material: null,
  set_crud_presentacion: null,
  set_crud_typeexistence: null,
}

const productsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.DOWNLOADING_PRODUCT_PRICES_LIST_PDF: {
      return {
        ...state,
        downloading_product_prices_list_pdf: action.payload
      }
    }

    case Actions.GET_ALL_PRODUCTS: {
      return {
        ...state,
        all_products: action.payload,
      }
    }
    case Actions.GET_PRODUCTS: {
      return {
        ...state,
        loading_products: action.payload.loading,
        products: action.payload.detalles ?? state.products,
        total_products: action.payload.totalRegistros ?? state.total_products
      }
    }
    case Actions.SEARCH_PRODUCTS: {
      return {
        ...state,
        loading_products_found: action.payload.loading,
        products_found: action.payload.data ?? state.products_found
      }
    }
    case Actions.DOWNLOADING_VALUED_INVENTORY_REPORT: {
      return {
        ...state,
        downloading_valued_inventory_report: action.payload
      }
    }

    case Actions.DOWNLOADING_PRODUCT_SHIPMENT_PDF: {
      return {
        ...state,
        downloading_product_shipment_pdf: action.payload
      }
    }

    case Actions.GET_MOVEMENTS_BY_PRODUCT: {
      return {
        ...state,
        loading_movements_by_product: action.payload.loading,
        movements_by_product: action.payload.data
      }
    }

    case Actions.GET_UNIT_MEASURES_PRODUCT: {
      return {
        ...state,
        loading_unit_measures_product: action.payload.loading,
        unit_measures_product: action.payload.data
      }
    }

    case Actions.GET_ALL_SORTS: {
      return {
        ...state,
        sorts: action.payload
      }
    }
    case Actions.GET_ALL_SUBSORTS: {
      return {
        ...state,
        subsorts: action.payload
      }
    }
    case Actions.GET_ALL_BRANDS: {
      return {
        ...state,
        brands: action.payload,
      }
    }
    case Actions.GET_ALL_MATERIALS: {
      return {
        ...state,
        materials: action.payload
      }
    }
    case Actions.GET_ALL_PRESENTATIONS: {
      return {
        ...state,
        presentations: action.payload
      }
    }
    case Actions.GET_ALL_TYPEEXISTENCES: {
      return {
        ...state,
        typeexistences: action.payload
      }
    }
    case Actions.GET_LAST_COST_PRICE: {
      return {
        ...state,
        loading_last_cost_price_product: action.payload.loading,
        last_cost_price_product: action.payload.data,
      }
    }
    case Actions.STOCK_RODUCT: {
      return {
        ...state,
        loading_stock_product: action.payload.loading,
        stock_product: action.payload.stock,
      }
    }
    case Actions.CRUD_PRODUCT: {
      return {
        ...state,
        loading_crud_product: action.payload.loading,
        crud_product: action.payload.crud,
        crud_product_data: action.payload.data,
      }
    }
    case Actions.CRUD_SORT: {
      return {
        ...state,
        set_crud_sort: action.payload,
      }
    }
    case Actions.CRUD_SUBSORT: {
      return {
        ...state,
        set_crud_subsort: action.payload,
      }
    }
    case Actions.CRUD_BRAND: {
      return {
        ...state,
        set_crud_brand: action.payload,
      }
    }
    case Actions.CRUD_MATERIAL: {
      return {
        ...state,
        set_crud_material: action.payload,
      }
    }
    case Actions.CRUD_PRESENTATION: {
      return {
        ...state,
        set_crud_presentacion: action.payload,
      }
    }
    case Actions.CRUD_TYPEEXISTENCE: {
      return {
        ...state,
        set_crud_typeexistence: action.payload,
      }
    }
    default: {
      return state
    }
  }
}
export default productsReducer
